import { render } from "./TermMain.vue?vue&type=template&id=19d472ff&scoped=true&ts=true"
import script from "./TermMain.vue?vue&type=script&lang=ts"
export * from "./TermMain.vue?vue&type=script&lang=ts"

import "./TermMain.vue?vue&type=style&index=0&id=19d472ff&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d472ff"]])

export default __exports__